import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ApiService } from '../api.service';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  // imports: [ɵInternalFormsSharedModule]
})
export class SignupComponent implements OnInit {
  loading:any
ShowCard:any;
  submitForm!: FormGroup;
  receivedCaptcha:any;
  otp: string = '';
otpStartTime!: number;
otpDuration = 180; // seconds
otpTimerInterval: any;
generatedOtp: string = '';
constructor(private service:ApiService,
  private titleService: Title, private metaService: Meta,
    private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router
){}
ngOnInit(): void {
 this.setMetaTags();
    this.setCanonicalUrl();

  this.submitForm = new FormGroup({
    name: new FormControl('',Validators.required),
    email: new FormControl('',Validators.required),
    mobileNumber: new FormControl('',Validators.required),
    address: new FormControl('',Validators.required),
    countryName: new FormControl('',Validators.required),
    stateName: new FormControl('',Validators.required),
    cityName: new FormControl('',Validators.required),
    pincode: new FormControl('',Validators.required),
    captcha: new FormControl('',Validators.required)




  })

}

getCaptcha(){
  let model ={
    mobileNumber:this.mobileNumber?.value,
    email:this.email?.value
  }

  let encrypt = {
    securePayload : this.service.encrypt(JSON.stringify(model))
  }
  this.service.getCaptcha(encrypt).then((res:any)=>{
    if (res.flag == 1) {
      this.receivedCaptcha =  JSON.parse(this.service.decryptData(res.data));
      this.captcha?.reset()
    } else {
      
    }
  }).catch((err)=>{
    Swal.fire({
      icon: 'warning',
      title: 'Something went wrong '+' '+ err.status,
      showConfirmButton: true,
      customClass:{
        popup:'popupClass',
        title:'titleClass',
        icon:'iconClass',
        confirmButton:'buttonClass'

      }
     
    });
  })
}


get name(){
  return this.submitForm.get('name')
}
get email(){
  return this.submitForm.get('email')
}
get mobileNumber(){
  return this.submitForm.get('mobileNumber')
}
get captcha(){
  return this.submitForm.get('captcha')
}
get countryName(){
  return this.submitForm.get('countryName')
}
get stateName(){
  return this.submitForm.get('stateName')
}
get cityName(){
  return this.submitForm.get('cityName')
}
get pincode(){
  return this.submitForm.get('pincode')
}
get address(){
  return this.submitForm.get('address')
}
openOtpDialog() {
  this.generateOtp(); // call API or mock

  this.otpStartTime = Date.now();

  Swal.fire({
    title: 'Enter OTP',
    html: `
      <p  style="margin-top:10px;">OTP send to ${this.email?.value}</p>

      <input style="text-align:center" id="otpInput" maxlength="6" class="swal2-input" type="tel" inputmode="numeric" pattern="[0-9]* placeholder="Enter 6 digit OTP">
      <p id="timerText" style="margin-top:10px;">Expires in 180 sec</p>
      <button id="resendBtn" class="swal2-confirm swal2-styled" disabled>Resend OTP</button>
    `,
    showConfirmButton: true,
    confirmButtonText: 'Verify OTP',
    allowOutsideClick: false,
        customClass: {
      
      confirmButton: 'buttonClass'
    },
    didOpen: () => {
      this.startOtpTimer();

      document.getElementById('resendBtn')?.addEventListener('click', () => {
        this.generateOtp();
        this.otpStartTime = Date.now();
      });
    },

    // ✅ MAIN FIX HERE
    preConfirm: () => {
      const otpInput: any = document.getElementById('otpInput');
      const value = otpInput?.value;

      if (!value || value.length !== 6) {
        Swal.showValidationMessage('Enter valid 6-digit OTP');
        return false;
      }

      if (value !== this.generatedOtp) {
        Swal.showValidationMessage('Invalid OTP'); // 👈 stays inside popup
        return false;
      }

      return value;
    }

  }).then((result) => {
    if (result.isConfirmed) {
      this.verifyOtpSuccess(); // ✅ only success flow here
    }
  });
}

startOtpTimer() {
  clearInterval(this.otpTimerInterval);

  this.otpTimerInterval = setInterval(() => {
    const now = Date.now();
    const elapsed = Math.floor((now - this.otpStartTime) / 1000);
    const remaining = this.otpDuration - elapsed;

    const timerText = document.getElementById('timerText');
    const resendBtn = document.getElementById('resendBtn') as HTMLButtonElement;

    if (remaining > 0) {
      if (timerText) {
        timerText.innerText = `Expires in ${remaining} sec`;
      }
    } else {
      clearInterval(this.otpTimerInterval);

      if (timerText) {
        timerText.innerText = `OTP expired`;
      }

      if (resendBtn) {
        resendBtn.disabled = false;
      }
    }
  }, 1000);
}

generateOtp() {

  let model = {
    email : this.email?.value,
    name : this.name?.value
  }
  let encrypt = {
        securePayload : this.service.encrypt(JSON.stringify(model)) 
      }

 this.service.getOTP(encrypt).then((res:any)=>{

  if (res.flag==1) {
  this.generatedOtp = JSON.parse(this.service.decryptData(res.data))
    
    
  } else {
      Swal.fire({
            icon: 'warning',
            title: res.message,
            showConfirmButton: true,
            customClass:{
              popup:'popupClass',
              title:'titleClass',
              icon:'iconClass',
        confirmButton:'buttonClass'
            }
            // timer: 1500
          });
      this.loading = false;
  }
 }).catch((err)=>{
   Swal.fire({
          icon: 'warning',
          title: 'Something went wrong '+' '+ err.status,
          showConfirmButton: true,
          customClass:{
            popup:'popupClass',
            title:'titleClass',
                icon:'iconClass',
        confirmButton:'buttonClass'
          }
         
        });
      this.loading = false;
 })

  
  
}
submit(){


if (this.submitForm.valid) {
    if (this.captcha?.value == this.receivedCaptcha) {
      this.openOtpDialog();
    } else {
      this.showAlert('warning', 'Captcha Invalid');
    }
  } else {
    this.showAlert('warning', 'Kindly fill all required fields');
    this.submitForm.markAllAsTouched();
  }

//   if (this.submitForm.valid) {
//     if (this.captcha?.value == this.receivedCaptcha) {
//       this.loading = true;
//       let model = {
//          name : this.name?.value,
// email : this.email?.value,
// mobileNumber : this.mobileNumber?.value,
// address : this.address?.value,
// countryName : this.countryName?.value,
// stateName : this.stateName?.value,
// cityName : this.cityName?.value,
// pincode : this.pincode?.value
//       }
//       let encrypt = {
//         securePayload : this.service.encrypt(JSON.stringify(model)) 
//       }
//       this.service.signUp(encrypt).then((res:any)=>{
//         if (res.flag ==1) {
//           Swal.fire({
//             icon: 'success',
//             title: 'Form Submitted Successfully! Thank you for reaching us, Our executives will contact you within 48hrs ',
//             showConfirmButton: true,
//             customClass:{
//               popup:'popupClass',
//               title:'titleClass',
//               icon:'iconClass',
//         confirmButton:'buttonClass'
//             }
//             // timer: 1500
//           });
//       this.loading = false;
// this.submitForm.reset()
//         } else {
//           Swal.fire({
//             icon: 'warning',
//             title: res.message,
//             showConfirmButton: true,
//             customClass:{
//               popup:'popupClass',
//               title:'titleClass',
//               icon:'iconClass',
//         confirmButton:'buttonClass'
//             }
//             // timer: 1500
//           });
//       this.loading = false;

//         }
//       }).catch((err)=>{
//         Swal.fire({
//           icon: 'warning',
//           title: 'Something went wrong '+' '+ err.status,
//           showConfirmButton: true,
//           customClass:{
//             popup:'popupClass',
//             title:'titleClass',
//                 icon:'iconClass',
//         confirmButton:'buttonClass'
//           }
         
//         });
//       this.loading = false;

//       })
//     } else {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Captcha Invalid',
//         showConfirmButton: true,
//         customClass:{
//           popup:'popupClass',
//           title:'titleClass',
//               icon:'iconClass',
//         confirmButton:'buttonClass'
//         }
       
//       });
      
//     }
//   } else {
//     Swal.fire({
//       icon: 'warning',
//       title: 'Kindly fill all required fields',
//       showConfirmButton: true,
      
//       customClass:{
//         popup:'popupClass',
//         title:'titleClass',
//             icon:'iconClass',
//         confirmButton:'buttonClass'
//       }
//       // timer: 1500
//     });
//     this.submitForm.markAllAsTouched();
//   }
}

verifyOtpSuccess() {
  this.loading = true;

  let model = {
    name: this.name?.value,
    email: this.email?.value,
    mobileNumber: this.mobileNumber?.value,
    address: this.address?.value,
    countryName: this.countryName?.value,
    stateName: this.stateName?.value,
    cityName: this.cityName?.value,
    pincode: this.pincode?.value
  };

  let encrypt = {
    securePayload: this.service.encrypt(JSON.stringify(model))
  };

  this.service.signUp(encrypt).then((res: any) => {
    if (res.flag == 1) {
      this.showAlert('success', 'Form Submitted Successfully!');
      this.submitForm.reset();
    } else {
      this.showAlert('warning', res.message);
    }
    this.loading = false;
  }).catch(err => {
    this.showAlert('warning', 'Something went wrong ' + err.status);
    this.loading = false;
  });
}
// verifyOtp(userOtp: string) {
//   if (userOtp !== this.generatedOtp) {
//     this.showAlert('warning', 'Invalid OTP');
//     return;
//   }

//   this.loading = true;

//   let model = {
//     name: this.name?.value,
//     email: this.email?.value,
//     mobileNumber: this.mobileNumber?.value,
//     address: this.address?.value,
//     countryName: this.countryName?.value,
//     stateName: this.stateName?.value,
//     cityName: this.cityName?.value,
//     pincode: this.pincode?.value
//   };

//   let encrypt = {
//     securePayload: this.service.encrypt(JSON.stringify(model))
//   };

//   this.service.signUp(encrypt).then((res: any) => {
//     if (res.flag == 1) {
//       this.showAlert('success', 'Form Submitted Successfully!');
//       this.submitForm.reset();
//     } else {
//       this.showAlert('warning', res.message);
//     }
//     this.loading = false;
//   }).catch(err => {
//     this.showAlert('warning', 'Something went wrong ' + err.status);
//     this.loading = false;
//   });
// }

showAlert(type: any, message: string) {
  Swal.fire({
    icon: type,
    title: message,
    showConfirmButton: true,
    allowOutsideClick: false,
    customClass: {
      popup: 'popupClass',
      title: 'titleClass',
      icon: 'iconClass',
      confirmButton: 'buttonClass'
    }
  });
}



 private setMetaTags(): void {
        // Set page title (works for both server and client)
        this.titleService.setTitle('Sign up | FA Check');
       
        // Update or add meta tags
        this.metaService.updateTag({ name: 'description', content: 'Sign up easily to manage verifications, access secure tools, and simplify your onboarding process.' });
        // this.metaService.updateTag({ name: 'author', content: 'Your Name' });
       
        // For keywords, use updateTag with proper attribute
//         this.metaService.updateTag({ name: 'keywords', content: 'Association Management Solution, Association Management Software, Best Association Management Solution'
//  });
       
        // Open Graph tags
        this.metaService.updateTag({ property: 'og:title', content: 'Sign up | FA Check' });
        this.metaService.updateTag({ property: 'og:description', content: 'Sign up easily to manage verifications, access secure tools, and simplify your onboarding process.' });
        this.metaService.updateTag({ property: 'og:url', content: `https://facheck.in${this.router.url}` });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
       
        // Twitter tags
        this.metaService.updateTag({ name: 'twitter:title', content: 'Sign up | FA Check' });
        this.metaService.updateTag({ name: 'twitter:description', content: 'Sign up easily to manage verifications, access secure tools, and simplify your onboarding process.' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
       
        // You can also add tags if they don't exist
        // this.addTagIfNotExists('og:image', { property: 'og:image', content: 'https://quickrentpay.com/assets/images/og-image.jpg' });
        // this.addTagIfNotExists('twitter:image', { name: 'twitter:image', content: 'https://quickrentpay.com/assets/images/twitter-image.jpg' });
    }
 
 setCanonicalUrl(): void {
    // Remove query parameters for clean canonical URL
    const cleanUrl = this.router.url.split('?')[0];
    const canonicalUrl = `https://facheck.in${cleanUrl}`;
   
    // Use the same DOM manipulation on both server and client
    this.updateCanonicalLink(canonicalUrl);
  }
 
  private updateCanonicalLink(url: string): void {
    // Find existing canonical link
    const existingLink = this.document.querySelector("link[rel='canonical']");
   
    if (existingLink) {
      // Update existing link if href is different
      const currentHref = existingLink.getAttribute('href');
      if (currentHref !== url) {
        this.renderer.setAttribute(existingLink, 'href', url);
      }
    } else {
      // Create new canonical link if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }
}
